import Cabecalho from "../components/Cabecalho/Cabecalho";
import HeroSecao from "../components/HeroSecao/HeroSecao";
import SobreMim from "../components/SobreMim/SobreMim";
import StackTecnologica from "../components/StackTecnologica/StackTecnologica";
import ProjetosDestaque from "../components/ProjetosDestaque/ProjetosDestaque";
import Experiencia from "../components/Experiencia/Experiencia";
import Diferenciais from "../components/Diferenciais/Diferenciais";
import Contato from "../components/Contato/Contato";
import Rodape from "../components/Rodape/Rodape";

const Home = () => {
  return (
    <main>
      <Cabecalho />
      <HeroSecao />
      <SobreMim />
      <StackTecnologica />
      <ProjetosDestaque />
      <Experiencia />
      <Diferenciais />
      <Contato />
      <Rodape />
    </main>
  );
};

export default Home;
